import { LegalBriefSection } from "../../redux/drafts/draftsSlice";
import { VISAVALUE } from "../../types/visa.type";
import { DraftType, UserProfile } from "./draft";

export enum DefaultTemplateStatus {
  PUBLISHED = "PUBLISHED",
  READY = "READY",
  PROCESSING = "PROCESSING",
  FAILED = "FAILED",
  INACTIVE = "INACTIVE"
}

// Align with backend TemplateSection; we reuse our LegalBriefSection shape
export type TemplateSection = LegalBriefSection;

export interface DefaultTemplate {
  default_template_id?: string;
  visa: VISAVALUE;
  visa_subtype?: string | null;
  draft_type: DraftType;
  sections: TemplateSection[];
  status: DefaultTemplateStatus;
  is_standard: boolean;
  created_at: string; // ISO date string
  updated_at: string | null; // ISO date string
  created_by: string;
  updated_by: string | null;
  created_by_email: string | null;
  updated_by_email: string | null;
}

export interface CreateDefaultTemplateRequest {
  visa: VISAVALUE;
  visa_subtype?: string | null;
  draft_type: DraftType;
  sections?: TemplateSection[];
  status?: DefaultTemplateStatus; // defaults to PROCESSING on backend
  is_standard?: boolean;
}

export interface UpdateDefaultTemplateRequest {
  visa?: VISAVALUE;
  visa_subtype?: string | null;
  draft_type?: DraftType;
  sections?: TemplateSection[];
  status?: DefaultTemplateStatus;
  is_standard?: boolean;
}

export type DefaultTemplateVersion = {
  version_id: string;
  template_id: string;
  created_at: string;
  created_by?: string | null;
  created_by_profile?: UserProfile | null;
  /**
   * Backend may return the snapshot either in a nested payload or with top-level fields.
   * Keep this permissive and extract defensively in the UI.
   */
  template_payload?: Record<string, unknown> | null;
  sections?: TemplateSection[] | null;
};
